export const truncateText = (text, maxLength = 25) => {
  if (!text) return "";
  const textStr = String(text);
  return textStr.length > maxLength
    ? `${textStr.substring(0, maxLength)}...`
    : textStr;
};
